import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
// import ReactToPrint from 'react-to-print';
import BarCode from 'react-barcode';

import QR from './qrCode';
import { qrcodeStyle } from './styles';
import InputFormat from '../../../../partials/inputForm'
import {isJsonString} from '../../../../utils/setting'
import PopupInterface from '../../../popUpInterface'
import QRCode from 'qrcode.react';
import { Link } from 'react-router-dom';
class QRCodeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      qrCodeValue: '',
      barCodeValue: '',
      service: {},
      qrcodeSize: 170,
      barcodeSize: 170,
      showQRCode: false
    }
  }
  componentDidMount() { 
    // this.props.serviceBranchDispatch.getBranchForOwner({ serviceCode: '' });
    let service = this.props.service
    let _this = this
    if(service.qrcode && isJsonString(service.qrcode)) {
      let qrcode = JSON.parse(service.qrcode)
      this.setState({
        qrCodeValue: `${qrcode.serviceCode} ${qrcode.serviceName} ${qrcode.website} ${qrcode.mobile}`,
        service: {
          no: qrcode.serviceCode,
          name: qrcode.serviceName,
          website: qrcode.website,
          mobile: qrcode.mobile
        }
      })
    }
    else 
    {
      this.setState({
        qrCodeValue: `${service.no} ${service.name} ${service.website} ${service.mobile}`,
        service: service,
      }, function() {
        _this.generateQRCode()
      }) 
    }


    if(service.barcode && isJsonString(service.barcode) && service.barcode !== null)
    {
      let barcode = JSON.parse(service.barcode)
      this.setState({
        barCodeValue: barcode.code ? barcode.code.toString() : '',
        code:  barcode.code ? barcode.code.toString() : '',
      })
    } 
    else {
      this.setState({
        barCodeValue: service.website ? `${service.website}` : ``,
        code:  service.website ? `${service.website}` : ``,
      }, function() {
        _this.generateBarCode()
      })
    }
  }
  generateBarCode = () => {
    // let canvas = document.getElementById('qrcodeCavas');
    // let dataURL = canvas.toDataURL();
    // console.log(dataURL);
    let code = this.state.code
    this.setState({
      barCodeValue: code
    })
    this.props.updateQRcode({barcode: JSON.stringify({
      code: this.state.code
    })})
  }
  generateQRCode = () => {
    let {t} = this.props
    let service = this.state.service
    let _this = this
    this.props.updateQRcode({qrcode: JSON.stringify({
      serviceCode: service.no,
      serviceName: service.name,
      website: service.website,
      mobile: service.mobile
    }) })
    this.setState({
      qrCodeValue: `${service.no} ${service.name} ${service.website} ${service.mobile}`
    }, function(){
      _this.props.handleSnackbar(t('service_ownerspa_servicedetail_generate_qr_code_successful'))
    })
  }
  changeSize =  (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: [value]
    })
  }
  handleChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    let service = this.state.service
    service[name] = value
    this.setState({
      service
    })
  }
  handleChangeBarCode = (e) => {
    let name = e.target.name
    let value = e.target.value
    // let barCode = this.state.barCode
    // barCode[name] = value
    this.setState({
      code: value
    })
  }
  // openPopup = (bool) => {
  //   this.PopupInterface.handleDialogOpen()
  //   this.setState({showQRCode: bool})
  //   // const canvas = document.getElementById("qrcodeCavas");
  //   // const pngUrl = canvas
  //   //   .toDataURL()
  //   // //   .replace("image/png", "image/octet-stream");
  //   // let downloadLink = document.createElement("a");
  //   // downloadLink.href = pngUrl;
  //   // downloadLink.download = "123456.png";
  //   // document.body.appendChild(downloadLink);
  //   // downloadLink.click();
  //   // document.body.removeChild(downloadLink);
  // };
  openPopup = (event, type) => {
    if(type === 'qrcode') this.setState({anchorElqrcode:  event.currentTarget})
    else  this.setState({anchorElBarCode:  event.currentTarget})
  }
  handleClose= (event, type) => {
    if(type === 'qrcode') this.setState({anchorElqrcode:  null})
    else this.setState({anchorElBarCode: null})
  }
  // handlePrint = (type) => {
  //   let {service, qrcodeSize, barcodeSize} = this.state
  //   if(type === 'qrcode') this.props.history.push(`/qrcode?serviceCode=${service.no}&size=${qrcodeSize}`)
  //   else this.props.history.push(`/barcode?serviceCode=${service.no}&size=${barcodeSize}`)
  // }
  closePopup = () => {
    this.setState({anchorElBarCode: null, anchorElqrcode: null})
  }
  render() { 
    // const {service = {}} = this.props;
    const { classes,t } = this.props;
    // let {serviceCode, serviceName, website, mobile} = this.state.qrcode
    let {barCodeValue, qrCodeValue, code, service, qrcodeSize, showQRCode, barcodeSize} = this.state
    return (
      <Fragment>
          <Grid container spacing={3}> 
            <Grid item xs={12} sm={3} >
              <Grid container>
                  <Grid item xs={12} sm={12} >
                    <InputFormat 
                          disableb   
                          name="no"
                          label={t("service_ownerspa_servicedetail_qr_code_service_code")} 
                          margin="normal"
                          required
                          value={service.no}
                          onChange={this.handleChange}
                      />
                  </Grid>
                  <Grid item xs={12} sm={12} >
                    <InputFormat 
                          name="name"
                          label={t("service_ownerspa_servicedetail_qr_code_service_name")} 
                          margin="normal"
                          required
                          value={service.name}
                          onChange={this.handleChange}
                      />
                  </Grid>
                  <Grid item xs={12} sm={12} >
                        <InputFormat 
                          name="website"
                          label={t("service_ownerspa_servicedetail_qr_code_website")} 
                          margin="normal"
                          required
                          value={service.website}
                          onChange={this.handleChange}
                      />
                  </Grid>
                  <Grid item xs={12} sm={12} >
                    <InputFormat 
                          name="mobile"
                          label={t("service_ownerspa_servicedetail_qr_code_mobile")} 
                          margin="normal"
                          required
                          value={service.mobile}
                          onChange={this.handleChange}
                      />
                  </Grid>
                  <Grid item xs={12} sm={12} >
                    <Button color="primary" onClick = {this.generateQRCode} size="large" variant="outlined" component="span" className={classes.button}>{t('service_ownerspa_servicedetail_generate_qrcode')}</Button>
                  </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={9} >
              <Grid container alignItems="center" justify="center" direction = 'column'>
                <Typography variant="h4" gutterBottom align="center">
                  {service.name}
                </Typography>
                <QR
                  ref={el => (this.componentRef = el)}
                  qrCodeValue={qrCodeValue}
                  size = {170}
                />
                <Button color="primary" onClick = {(e) => this.openPopup(e, 'qrcode')} size="large" variant="contained" component="span">{t('service_ownerspa_servicedetail_feature_print_qrcode')}</Button>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElqrcode}
                  keepMounted
                  open={Boolean(this.state.anchorElqrcode)}
                  onClose={() => this.setState({anchorElqrcode: null})}
                > 
                  <div className = {classes.containerMenu}>
                    <Typography>{t('service_ownerspa_servicedetail_enter_qrcode_size')}</Typography>
                    <InputFormat 
                      name="qrcodeSize"
                      label={t("service_ownerspa_servicedetail_qrcode_size")} 
                      margin="normal"
                      value={qrcodeSize}
                      onChange={this.changeSize}
                      fullWidth = {false}
                    />
                    <Link to={`/qrcode?serviceCode=${service.no}&size=${qrcodeSize}`} target="_blank">
                      <Button  onClick = {this.closePopup}  color="primary" size="large" variant="contained" className={classes.button} component="span">{t('service_ownerspa_servicedetail_feature_print_qrcode')}</Button>
                    </Link>

                 </div>
                </Menu>
                
                <Typography variant="subtitle1" gutterBottom align="center">
                  {service.address}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Grid container>
                <Grid item xs={12} sm={12} >
                    <InputFormat 
                      name="barCode"
                      label={t("service_ownerspa_servicedetail_qr_code_code")} 
                      margin="normal"
                      required
                      value={code}
                      onChange={this.handleChangeBarCode}
                  />
                </Grid>
                <Grid item xs={12} sm={12} >
                 <Button color="primary" onClick = {this.generateBarCode} size="large" variant="outlined" component="span" className={classes.button}>{t('service_ownerspa_servicedetail_generate_barcode')}</Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Grid container alignItems="center" justify="center" direction = 'column'>
                {barCodeValue ? <BarCode
                    value={barCodeValue}
                    height={112}
                    lineColor='#000000'
                    background= '#ffffff'
                    renderer = 'canvas'
                /> 
                : ''}
                <Link to={`/barcode?serviceCode=${service.no}`} target="_blank">
                  <Button color="primary" size="large" variant="contained" component="span">{t('service_ownerspa_servicedetail_feature_print_barcode')}</Button>
                </Link>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElBarCode}
                  keepMounted
                  open={Boolean(this.state.anchorElBarCode)}
                  onClose={(e) => this.setState({anchorElBarCode: null})}
                > 
                  <div className = {classes.containerMenu}>
                    <Typography>{t('service_ownerspa_servicedetail_enter_barcode_height')}</Typography>
                    <InputFormat 
                      name="barcodeSize"
                      label={t("service_ownerspa_servicedetail_barcode_height")} 
                      margin="normal"
                      value={barcodeSize}
                      onChange={this.changeSize}
                      fullWidth = {false}
                    />
                    <Link to={`/barcode?serviceCode=${service.no}&size=${qrcodeSize}`} target="_blank">
                      <Button onClick = {this.closePopup} color="primary" size="large" variant="contained" component="span" className={classes.button}>{t('service_ownerspa_servicedetail_feature_print_qrcode')}</Button>
                    </Link>
                  </div>
                </Menu>
              </Grid>
            </Grid>
          </Grid>

      </Fragment>
    )
  }
}

QRCodeComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = state => ({ 
  
});
const mapDispatch = dispatch => ({
  serviceBranchDispatch: dispatch.serviceBranch,
  updateQRcode: dispatch.service.updateQRcode
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(qrcodeStyle, { withTheme: true })(QRCodeComponent)));